import { render, staticRenderFns } from "./AllRestaurants.vue?vue&type=template&id=4749a6a2&scoped=true&"
import script from "./AllRestaurants.vue?vue&type=script&lang=js&"
export * from "./AllRestaurants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4749a6a2",
  null
  
)

export default component.exports